import { render, staticRenderFns } from "./AccountPasswordChange.vue?vue&type=template&id=5c7f80e4&"
import script from "./AccountPasswordChange.vue?vue&type=script&lang=js&"
export * from "./AccountPasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports